/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JoinRouteImport } from './routes/join'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorksheetsIndexRouteImport } from './routes/worksheets/index'
import { Route as ParentIndexRouteImport } from './routes/parent/index'
import { Route as MeIndexRouteImport } from './routes/me/index'
import { Route as LessonPlansIndexRouteImport } from './routes/lesson-plans/index'
import { Route as GamesIndexRouteImport } from './routes/games/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as WorksheetsSlugRouteImport } from './routes/worksheets/$slug'
import { Route as ParentOnboardingRouteImport } from './routes/parent/onboarding'
import { Route as MeProgressRouteImport } from './routes/me/progress'
import { Route as MePreferencesRouteImport } from './routes/me/preferences'
import { Route as MeBadgesRouteImport } from './routes/me/badges'
import { Route as LessonPlansNewRouteImport } from './routes/lesson-plans/new'
import { Route as GamesGameSlugRouteImport } from './routes/games/$gameSlug'
import { Route as DashboardPanduanBadgesRouteImport } from './routes/dashboard/panduan-badges'
import { Route as DashboardLevelingGuideRouteImport } from './routes/dashboard/leveling-guide'
import { Route as AdminWorksheetsRouteImport } from './routes/admin/worksheets'
import { Route as AdminTutorsRouteImport } from './routes/admin/tutors'
import { Route as AdminSyncRouteImport } from './routes/admin/sync'
import { Route as AdminStudentsRouteImport } from './routes/admin/students'
import { Route as AdminParentsRouteImport } from './routes/admin/parents'
import { Route as AdminGamesRouteImport } from './routes/admin/games'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as LessonPlansIdIndexRouteImport } from './routes/lesson-plans/$id/index'
import { Route as DashboardStudentsIndexRouteImport } from './routes/dashboard/students/index'
import { Route as DashboardClassesIndexRouteImport } from './routes/dashboard/classes/index'
import { Route as RcSessionSessionIdRouteImport } from './routes/rc/session/$sessionId'
import { Route as ParentChildrenStudentIdRouteImport } from './routes/parent/children/$studentId'
import { Route as LessonPlansIdPrintRouteImport } from './routes/lesson-plans/$id/print'
import { Route as DashboardStudentsStudentIdRouteImport } from './routes/dashboard/students/$studentId'
import { Route as DashboardReportsHistoryRouteImport } from './routes/dashboard/reports/history'
import { Route as DashboardReportsComposeRouteImport } from './routes/dashboard/reports/compose'
import { Route as DashboardClassesNewRouteImport } from './routes/dashboard/classes/new'
import { Route as DashboardClassesClassIdRouteImport } from './routes/dashboard/classes/$classId'
import { Route as DashboardClassesClassIdProgressRouteImport } from './routes/dashboard/classes/$classId.progress'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorksheetsIndexRoute = WorksheetsIndexRouteImport.update({
  id: '/worksheets/',
  path: '/worksheets/',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentIndexRoute = ParentIndexRouteImport.update({
  id: '/parent/',
  path: '/parent/',
  getParentRoute: () => rootRouteImport,
} as any)
const MeIndexRoute = MeIndexRouteImport.update({
  id: '/me/',
  path: '/me/',
  getParentRoute: () => rootRouteImport,
} as any)
const LessonPlansIndexRoute = LessonPlansIndexRouteImport.update({
  id: '/lesson-plans/',
  path: '/lesson-plans/',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIndexRoute = GamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorksheetsSlugRoute = WorksheetsSlugRouteImport.update({
  id: '/worksheets/$slug',
  path: '/worksheets/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentOnboardingRoute = ParentOnboardingRouteImport.update({
  id: '/parent/onboarding',
  path: '/parent/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const MeProgressRoute = MeProgressRouteImport.update({
  id: '/me/progress',
  path: '/me/progress',
  getParentRoute: () => rootRouteImport,
} as any)
const MePreferencesRoute = MePreferencesRouteImport.update({
  id: '/me/preferences',
  path: '/me/preferences',
  getParentRoute: () => rootRouteImport,
} as any)
const MeBadgesRoute = MeBadgesRouteImport.update({
  id: '/me/badges',
  path: '/me/badges',
  getParentRoute: () => rootRouteImport,
} as any)
const LessonPlansNewRoute = LessonPlansNewRouteImport.update({
  id: '/lesson-plans/new',
  path: '/lesson-plans/new',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesGameSlugRoute = GamesGameSlugRouteImport.update({
  id: '/games/$gameSlug',
  path: '/games/$gameSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPanduanBadgesRoute = DashboardPanduanBadgesRouteImport.update({
  id: '/dashboard/panduan-badges',
  path: '/dashboard/panduan-badges',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardLevelingGuideRoute = DashboardLevelingGuideRouteImport.update({
  id: '/dashboard/leveling-guide',
  path: '/dashboard/leveling-guide',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorksheetsRoute = AdminWorksheetsRouteImport.update({
  id: '/admin/worksheets',
  path: '/admin/worksheets',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTutorsRoute = AdminTutorsRouteImport.update({
  id: '/admin/tutors',
  path: '/admin/tutors',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSyncRoute = AdminSyncRouteImport.update({
  id: '/admin/sync',
  path: '/admin/sync',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStudentsRoute = AdminStudentsRouteImport.update({
  id: '/admin/students',
  path: '/admin/students',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminParentsRoute = AdminParentsRouteImport.update({
  id: '/admin/parents',
  path: '/admin/parents',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGamesRoute = AdminGamesRouteImport.update({
  id: '/admin/games',
  path: '/admin/games',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const LessonPlansIdIndexRoute = LessonPlansIdIndexRouteImport.update({
  id: '/lesson-plans/$id/',
  path: '/lesson-plans/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardStudentsIndexRoute = DashboardStudentsIndexRouteImport.update({
  id: '/dashboard/students/',
  path: '/dashboard/students/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardClassesIndexRoute = DashboardClassesIndexRouteImport.update({
  id: '/dashboard/classes/',
  path: '/dashboard/classes/',
  getParentRoute: () => rootRouteImport,
} as any)
const RcSessionSessionIdRoute = RcSessionSessionIdRouteImport.update({
  id: '/rc/session/$sessionId',
  path: '/rc/session/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentChildrenStudentIdRoute = ParentChildrenStudentIdRouteImport.update({
  id: '/parent/children/$studentId',
  path: '/parent/children/$studentId',
  getParentRoute: () => rootRouteImport,
} as any)
const LessonPlansIdPrintRoute = LessonPlansIdPrintRouteImport.update({
  id: '/lesson-plans/$id/print',
  path: '/lesson-plans/$id/print',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardStudentsStudentIdRoute =
  DashboardStudentsStudentIdRouteImport.update({
    id: '/dashboard/students/$studentId',
    path: '/dashboard/students/$studentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardReportsHistoryRoute = DashboardReportsHistoryRouteImport.update({
  id: '/dashboard/reports/history',
  path: '/dashboard/reports/history',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardReportsComposeRoute = DashboardReportsComposeRouteImport.update({
  id: '/dashboard/reports/compose',
  path: '/dashboard/reports/compose',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardClassesNewRoute = DashboardClassesNewRouteImport.update({
  id: '/dashboard/classes/new',
  path: '/dashboard/classes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardClassesClassIdRoute = DashboardClassesClassIdRouteImport.update({
  id: '/dashboard/classes/$classId',
  path: '/dashboard/classes/$classId',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardClassesClassIdProgressRoute =
  DashboardClassesClassIdProgressRouteImport.update({
    id: '/progress',
    path: '/progress',
    getParentRoute: () => DashboardClassesClassIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/games': typeof AdminGamesRoute
  '/admin/parents': typeof AdminParentsRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/sync': typeof AdminSyncRoute
  '/admin/tutors': typeof AdminTutorsRoute
  '/admin/worksheets': typeof AdminWorksheetsRoute
  '/dashboard/leveling-guide': typeof DashboardLevelingGuideRoute
  '/dashboard/panduan-badges': typeof DashboardPanduanBadgesRoute
  '/games/$gameSlug': typeof GamesGameSlugRoute
  '/lesson-plans/new': typeof LessonPlansNewRoute
  '/me/badges': typeof MeBadgesRoute
  '/me/preferences': typeof MePreferencesRoute
  '/me/progress': typeof MeProgressRoute
  '/parent/onboarding': typeof ParentOnboardingRoute
  '/worksheets/$slug': typeof WorksheetsSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/games/': typeof GamesIndexRoute
  '/lesson-plans/': typeof LessonPlansIndexRoute
  '/me/': typeof MeIndexRoute
  '/parent/': typeof ParentIndexRoute
  '/worksheets/': typeof WorksheetsIndexRoute
  '/dashboard/classes/$classId': typeof DashboardClassesClassIdRouteWithChildren
  '/dashboard/classes/new': typeof DashboardClassesNewRoute
  '/dashboard/reports/compose': typeof DashboardReportsComposeRoute
  '/dashboard/reports/history': typeof DashboardReportsHistoryRoute
  '/dashboard/students/$studentId': typeof DashboardStudentsStudentIdRoute
  '/lesson-plans/$id/print': typeof LessonPlansIdPrintRoute
  '/parent/children/$studentId': typeof ParentChildrenStudentIdRoute
  '/rc/session/$sessionId': typeof RcSessionSessionIdRoute
  '/dashboard/classes/': typeof DashboardClassesIndexRoute
  '/dashboard/students/': typeof DashboardStudentsIndexRoute
  '/lesson-plans/$id/': typeof LessonPlansIdIndexRoute
  '/dashboard/classes/$classId/progress': typeof DashboardClassesClassIdProgressRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/games': typeof AdminGamesRoute
  '/admin/parents': typeof AdminParentsRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/sync': typeof AdminSyncRoute
  '/admin/tutors': typeof AdminTutorsRoute
  '/admin/worksheets': typeof AdminWorksheetsRoute
  '/dashboard/leveling-guide': typeof DashboardLevelingGuideRoute
  '/dashboard/panduan-badges': typeof DashboardPanduanBadgesRoute
  '/games/$gameSlug': typeof GamesGameSlugRoute
  '/lesson-plans/new': typeof LessonPlansNewRoute
  '/me/badges': typeof MeBadgesRoute
  '/me/preferences': typeof MePreferencesRoute
  '/me/progress': typeof MeProgressRoute
  '/parent/onboarding': typeof ParentOnboardingRoute
  '/worksheets/$slug': typeof WorksheetsSlugRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/games': typeof GamesIndexRoute
  '/lesson-plans': typeof LessonPlansIndexRoute
  '/me': typeof MeIndexRoute
  '/parent': typeof ParentIndexRoute
  '/worksheets': typeof WorksheetsIndexRoute
  '/dashboard/classes/$classId': typeof DashboardClassesClassIdRouteWithChildren
  '/dashboard/classes/new': typeof DashboardClassesNewRoute
  '/dashboard/reports/compose': typeof DashboardReportsComposeRoute
  '/dashboard/reports/history': typeof DashboardReportsHistoryRoute
  '/dashboard/students/$studentId': typeof DashboardStudentsStudentIdRoute
  '/lesson-plans/$id/print': typeof LessonPlansIdPrintRoute
  '/parent/children/$studentId': typeof ParentChildrenStudentIdRoute
  '/rc/session/$sessionId': typeof RcSessionSessionIdRoute
  '/dashboard/classes': typeof DashboardClassesIndexRoute
  '/dashboard/students': typeof DashboardStudentsIndexRoute
  '/lesson-plans/$id': typeof LessonPlansIdIndexRoute
  '/dashboard/classes/$classId/progress': typeof DashboardClassesClassIdProgressRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/games': typeof AdminGamesRoute
  '/admin/parents': typeof AdminParentsRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/sync': typeof AdminSyncRoute
  '/admin/tutors': typeof AdminTutorsRoute
  '/admin/worksheets': typeof AdminWorksheetsRoute
  '/dashboard/leveling-guide': typeof DashboardLevelingGuideRoute
  '/dashboard/panduan-badges': typeof DashboardPanduanBadgesRoute
  '/games/$gameSlug': typeof GamesGameSlugRoute
  '/lesson-plans/new': typeof LessonPlansNewRoute
  '/me/badges': typeof MeBadgesRoute
  '/me/preferences': typeof MePreferencesRoute
  '/me/progress': typeof MeProgressRoute
  '/parent/onboarding': typeof ParentOnboardingRoute
  '/worksheets/$slug': typeof WorksheetsSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/games/': typeof GamesIndexRoute
  '/lesson-plans/': typeof LessonPlansIndexRoute
  '/me/': typeof MeIndexRoute
  '/parent/': typeof ParentIndexRoute
  '/worksheets/': typeof WorksheetsIndexRoute
  '/dashboard/classes/$classId': typeof DashboardClassesClassIdRouteWithChildren
  '/dashboard/classes/new': typeof DashboardClassesNewRoute
  '/dashboard/reports/compose': typeof DashboardReportsComposeRoute
  '/dashboard/reports/history': typeof DashboardReportsHistoryRoute
  '/dashboard/students/$studentId': typeof DashboardStudentsStudentIdRoute
  '/lesson-plans/$id/print': typeof LessonPlansIdPrintRoute
  '/parent/children/$studentId': typeof ParentChildrenStudentIdRoute
  '/rc/session/$sessionId': typeof RcSessionSessionIdRoute
  '/dashboard/classes/': typeof DashboardClassesIndexRoute
  '/dashboard/students/': typeof DashboardStudentsIndexRoute
  '/lesson-plans/$id/': typeof LessonPlansIdIndexRoute
  '/dashboard/classes/$classId/progress': typeof DashboardClassesClassIdProgressRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/join'
    | '/login'
    | '/reset-password'
    | '/admin/audit'
    | '/admin/games'
    | '/admin/parents'
    | '/admin/students'
    | '/admin/sync'
    | '/admin/tutors'
    | '/admin/worksheets'
    | '/dashboard/leveling-guide'
    | '/dashboard/panduan-badges'
    | '/games/$gameSlug'
    | '/lesson-plans/new'
    | '/me/badges'
    | '/me/preferences'
    | '/me/progress'
    | '/parent/onboarding'
    | '/worksheets/$slug'
    | '/admin/'
    | '/dashboard/'
    | '/games/'
    | '/lesson-plans/'
    | '/me/'
    | '/parent/'
    | '/worksheets/'
    | '/dashboard/classes/$classId'
    | '/dashboard/classes/new'
    | '/dashboard/reports/compose'
    | '/dashboard/reports/history'
    | '/dashboard/students/$studentId'
    | '/lesson-plans/$id/print'
    | '/parent/children/$studentId'
    | '/rc/session/$sessionId'
    | '/dashboard/classes/'
    | '/dashboard/students/'
    | '/lesson-plans/$id/'
    | '/dashboard/classes/$classId/progress'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/join'
    | '/login'
    | '/reset-password'
    | '/admin/audit'
    | '/admin/games'
    | '/admin/parents'
    | '/admin/students'
    | '/admin/sync'
    | '/admin/tutors'
    | '/admin/worksheets'
    | '/dashboard/leveling-guide'
    | '/dashboard/panduan-badges'
    | '/games/$gameSlug'
    | '/lesson-plans/new'
    | '/me/badges'
    | '/me/preferences'
    | '/me/progress'
    | '/parent/onboarding'
    | '/worksheets/$slug'
    | '/admin'
    | '/dashboard'
    | '/games'
    | '/lesson-plans'
    | '/me'
    | '/parent'
    | '/worksheets'
    | '/dashboard/classes/$classId'
    | '/dashboard/classes/new'
    | '/dashboard/reports/compose'
    | '/dashboard/reports/history'
    | '/dashboard/students/$studentId'
    | '/lesson-plans/$id/print'
    | '/parent/children/$studentId'
    | '/rc/session/$sessionId'
    | '/dashboard/classes'
    | '/dashboard/students'
    | '/lesson-plans/$id'
    | '/dashboard/classes/$classId/progress'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/join'
    | '/login'
    | '/reset-password'
    | '/admin/audit'
    | '/admin/games'
    | '/admin/parents'
    | '/admin/students'
    | '/admin/sync'
    | '/admin/tutors'
    | '/admin/worksheets'
    | '/dashboard/leveling-guide'
    | '/dashboard/panduan-badges'
    | '/games/$gameSlug'
    | '/lesson-plans/new'
    | '/me/badges'
    | '/me/preferences'
    | '/me/progress'
    | '/parent/onboarding'
    | '/worksheets/$slug'
    | '/admin/'
    | '/dashboard/'
    | '/games/'
    | '/lesson-plans/'
    | '/me/'
    | '/parent/'
    | '/worksheets/'
    | '/dashboard/classes/$classId'
    | '/dashboard/classes/new'
    | '/dashboard/reports/compose'
    | '/dashboard/reports/history'
    | '/dashboard/students/$studentId'
    | '/lesson-plans/$id/print'
    | '/parent/children/$studentId'
    | '/rc/session/$sessionId'
    | '/dashboard/classes/'
    | '/dashboard/students/'
    | '/lesson-plans/$id/'
    | '/dashboard/classes/$classId/progress'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminGamesRoute: typeof AdminGamesRoute
  AdminParentsRoute: typeof AdminParentsRoute
  AdminStudentsRoute: typeof AdminStudentsRoute
  AdminSyncRoute: typeof AdminSyncRoute
  AdminTutorsRoute: typeof AdminTutorsRoute
  AdminWorksheetsRoute: typeof AdminWorksheetsRoute
  DashboardLevelingGuideRoute: typeof DashboardLevelingGuideRoute
  DashboardPanduanBadgesRoute: typeof DashboardPanduanBadgesRoute
  GamesGameSlugRoute: typeof GamesGameSlugRoute
  LessonPlansNewRoute: typeof LessonPlansNewRoute
  MeBadgesRoute: typeof MeBadgesRoute
  MePreferencesRoute: typeof MePreferencesRoute
  MeProgressRoute: typeof MeProgressRoute
  ParentOnboardingRoute: typeof ParentOnboardingRoute
  WorksheetsSlugRoute: typeof WorksheetsSlugRoute
  AdminIndexRoute: typeof AdminIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  GamesIndexRoute: typeof GamesIndexRoute
  LessonPlansIndexRoute: typeof LessonPlansIndexRoute
  MeIndexRoute: typeof MeIndexRoute
  ParentIndexRoute: typeof ParentIndexRoute
  WorksheetsIndexRoute: typeof WorksheetsIndexRoute
  DashboardClassesClassIdRoute: typeof DashboardClassesClassIdRouteWithChildren
  DashboardClassesNewRoute: typeof DashboardClassesNewRoute
  DashboardReportsComposeRoute: typeof DashboardReportsComposeRoute
  DashboardReportsHistoryRoute: typeof DashboardReportsHistoryRoute
  DashboardStudentsStudentIdRoute: typeof DashboardStudentsStudentIdRoute
  LessonPlansIdPrintRoute: typeof LessonPlansIdPrintRoute
  ParentChildrenStudentIdRoute: typeof ParentChildrenStudentIdRoute
  RcSessionSessionIdRoute: typeof RcSessionSessionIdRoute
  DashboardClassesIndexRoute: typeof DashboardClassesIndexRoute
  DashboardStudentsIndexRoute: typeof DashboardStudentsIndexRoute
  LessonPlansIdIndexRoute: typeof LessonPlansIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/worksheets/': {
      id: '/worksheets/'
      path: '/worksheets'
      fullPath: '/worksheets/'
      preLoaderRoute: typeof WorksheetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/': {
      id: '/parent/'
      path: '/parent'
      fullPath: '/parent/'
      preLoaderRoute: typeof ParentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/': {
      id: '/me/'
      path: '/me'
      fullPath: '/me/'
      preLoaderRoute: typeof MeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lesson-plans/': {
      id: '/lesson-plans/'
      path: '/lesson-plans'
      fullPath: '/lesson-plans/'
      preLoaderRoute: typeof LessonPlansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/': {
      id: '/games/'
      path: '/games'
      fullPath: '/games/'
      preLoaderRoute: typeof GamesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/worksheets/$slug': {
      id: '/worksheets/$slug'
      path: '/worksheets/$slug'
      fullPath: '/worksheets/$slug'
      preLoaderRoute: typeof WorksheetsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/onboarding': {
      id: '/parent/onboarding'
      path: '/parent/onboarding'
      fullPath: '/parent/onboarding'
      preLoaderRoute: typeof ParentOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/progress': {
      id: '/me/progress'
      path: '/me/progress'
      fullPath: '/me/progress'
      preLoaderRoute: typeof MeProgressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/preferences': {
      id: '/me/preferences'
      path: '/me/preferences'
      fullPath: '/me/preferences'
      preLoaderRoute: typeof MePreferencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/badges': {
      id: '/me/badges'
      path: '/me/badges'
      fullPath: '/me/badges'
      preLoaderRoute: typeof MeBadgesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lesson-plans/new': {
      id: '/lesson-plans/new'
      path: '/lesson-plans/new'
      fullPath: '/lesson-plans/new'
      preLoaderRoute: typeof LessonPlansNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$gameSlug': {
      id: '/games/$gameSlug'
      path: '/games/$gameSlug'
      fullPath: '/games/$gameSlug'
      preLoaderRoute: typeof GamesGameSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/panduan-badges': {
      id: '/dashboard/panduan-badges'
      path: '/dashboard/panduan-badges'
      fullPath: '/dashboard/panduan-badges'
      preLoaderRoute: typeof DashboardPanduanBadgesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/leveling-guide': {
      id: '/dashboard/leveling-guide'
      path: '/dashboard/leveling-guide'
      fullPath: '/dashboard/leveling-guide'
      preLoaderRoute: typeof DashboardLevelingGuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/worksheets': {
      id: '/admin/worksheets'
      path: '/admin/worksheets'
      fullPath: '/admin/worksheets'
      preLoaderRoute: typeof AdminWorksheetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tutors': {
      id: '/admin/tutors'
      path: '/admin/tutors'
      fullPath: '/admin/tutors'
      preLoaderRoute: typeof AdminTutorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sync': {
      id: '/admin/sync'
      path: '/admin/sync'
      fullPath: '/admin/sync'
      preLoaderRoute: typeof AdminSyncRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/students': {
      id: '/admin/students'
      path: '/admin/students'
      fullPath: '/admin/students'
      preLoaderRoute: typeof AdminStudentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/parents': {
      id: '/admin/parents'
      path: '/admin/parents'
      fullPath: '/admin/parents'
      preLoaderRoute: typeof AdminParentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/games': {
      id: '/admin/games'
      path: '/admin/games'
      fullPath: '/admin/games'
      preLoaderRoute: typeof AdminGamesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lesson-plans/$id/': {
      id: '/lesson-plans/$id/'
      path: '/lesson-plans/$id'
      fullPath: '/lesson-plans/$id/'
      preLoaderRoute: typeof LessonPlansIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/students/': {
      id: '/dashboard/students/'
      path: '/dashboard/students'
      fullPath: '/dashboard/students/'
      preLoaderRoute: typeof DashboardStudentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/classes/': {
      id: '/dashboard/classes/'
      path: '/dashboard/classes'
      fullPath: '/dashboard/classes/'
      preLoaderRoute: typeof DashboardClassesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rc/session/$sessionId': {
      id: '/rc/session/$sessionId'
      path: '/rc/session/$sessionId'
      fullPath: '/rc/session/$sessionId'
      preLoaderRoute: typeof RcSessionSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/children/$studentId': {
      id: '/parent/children/$studentId'
      path: '/parent/children/$studentId'
      fullPath: '/parent/children/$studentId'
      preLoaderRoute: typeof ParentChildrenStudentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lesson-plans/$id/print': {
      id: '/lesson-plans/$id/print'
      path: '/lesson-plans/$id/print'
      fullPath: '/lesson-plans/$id/print'
      preLoaderRoute: typeof LessonPlansIdPrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/students/$studentId': {
      id: '/dashboard/students/$studentId'
      path: '/dashboard/students/$studentId'
      fullPath: '/dashboard/students/$studentId'
      preLoaderRoute: typeof DashboardStudentsStudentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/reports/history': {
      id: '/dashboard/reports/history'
      path: '/dashboard/reports/history'
      fullPath: '/dashboard/reports/history'
      preLoaderRoute: typeof DashboardReportsHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/reports/compose': {
      id: '/dashboard/reports/compose'
      path: '/dashboard/reports/compose'
      fullPath: '/dashboard/reports/compose'
      preLoaderRoute: typeof DashboardReportsComposeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/classes/new': {
      id: '/dashboard/classes/new'
      path: '/dashboard/classes/new'
      fullPath: '/dashboard/classes/new'
      preLoaderRoute: typeof DashboardClassesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/classes/$classId': {
      id: '/dashboard/classes/$classId'
      path: '/dashboard/classes/$classId'
      fullPath: '/dashboard/classes/$classId'
      preLoaderRoute: typeof DashboardClassesClassIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/classes/$classId/progress': {
      id: '/dashboard/classes/$classId/progress'
      path: '/progress'
      fullPath: '/dashboard/classes/$classId/progress'
      preLoaderRoute: typeof DashboardClassesClassIdProgressRouteImport
      parentRoute: typeof DashboardClassesClassIdRoute
    }
  }
}

interface DashboardClassesClassIdRouteChildren {
  DashboardClassesClassIdProgressRoute: typeof DashboardClassesClassIdProgressRoute
}

const DashboardClassesClassIdRouteChildren: DashboardClassesClassIdRouteChildren =
  {
    DashboardClassesClassIdProgressRoute: DashboardClassesClassIdProgressRoute,
  }

const DashboardClassesClassIdRouteWithChildren =
  DashboardClassesClassIdRoute._addFileChildren(
    DashboardClassesClassIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminGamesRoute: AdminGamesRoute,
  AdminParentsRoute: AdminParentsRoute,
  AdminStudentsRoute: AdminStudentsRoute,
  AdminSyncRoute: AdminSyncRoute,
  AdminTutorsRoute: AdminTutorsRoute,
  AdminWorksheetsRoute: AdminWorksheetsRoute,
  DashboardLevelingGuideRoute: DashboardLevelingGuideRoute,
  DashboardPanduanBadgesRoute: DashboardPanduanBadgesRoute,
  GamesGameSlugRoute: GamesGameSlugRoute,
  LessonPlansNewRoute: LessonPlansNewRoute,
  MeBadgesRoute: MeBadgesRoute,
  MePreferencesRoute: MePreferencesRoute,
  MeProgressRoute: MeProgressRoute,
  ParentOnboardingRoute: ParentOnboardingRoute,
  WorksheetsSlugRoute: WorksheetsSlugRoute,
  AdminIndexRoute: AdminIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  GamesIndexRoute: GamesIndexRoute,
  LessonPlansIndexRoute: LessonPlansIndexRoute,
  MeIndexRoute: MeIndexRoute,
  ParentIndexRoute: ParentIndexRoute,
  WorksheetsIndexRoute: WorksheetsIndexRoute,
  DashboardClassesClassIdRoute: DashboardClassesClassIdRouteWithChildren,
  DashboardClassesNewRoute: DashboardClassesNewRoute,
  DashboardReportsComposeRoute: DashboardReportsComposeRoute,
  DashboardReportsHistoryRoute: DashboardReportsHistoryRoute,
  DashboardStudentsStudentIdRoute: DashboardStudentsStudentIdRoute,
  LessonPlansIdPrintRoute: LessonPlansIdPrintRoute,
  ParentChildrenStudentIdRoute: ParentChildrenStudentIdRoute,
  RcSessionSessionIdRoute: RcSessionSessionIdRoute,
  DashboardClassesIndexRoute: DashboardClassesIndexRoute,
  DashboardStudentsIndexRoute: DashboardStudentsIndexRoute,
  LessonPlansIdIndexRoute: LessonPlansIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
